(ns ballot-scout-v2-frontend.components.tooltip)

(defn tooltip [content tooltip-text]
  [:table {:class "tooltip"}
   [:tr
    [:td content]
    [:td {:class "ml-4 tooltiptext box"}
     tooltip-text]]])
